{
  "age-groups": [
    {
      "Elite": [
        { "group": "16-24" },
        { "group": "25-29" },
        { "group": "30-34" },
        { "group": "35-39" },
        { "group": "40-44" }
      ],
      "Open": [
        { "group": "16-24" },
        { "group": "25-29" },
        { "group": "30-34" },
        { "group": "35-39" },
        { "group": "40-44" },
        { "group": "45-49" },
        { "group": "50-54" },
        { "group": "55-59" },
        { "group": "60-64" },
        { "group": "65-69" },
        { "group": "70-74" },
        { "group": "75-79" },
        { "group": "80-84" },
        { "group": "85-89" }
      ],
      "Pro": [
        { "group": "16-24" },
        { "group": "25-29" },
        { "group": "30-34" },
        { "group": "35-39" },
        { "group": "40-44" },
        { "group": "45-49" },
        { "group": "50-54" },
        { "group": "55-59" },
        { "group": "60-64" },
        { "group": "65-69" },
        { "group": "70-74" }
      ],
      "Doubles": [
        { "group": "16-24" },
        { "group": "25-29" },
        { "group": "30-34" },
        { "group": "35-39" },
        { "group": "40-44" },
        { "group": "45-49" },
        { "group": "50-54" },
        { "group": "55-59" },
        { "group": "60-64" },
        { "group": "65-69" },
        { "group": "70-74" },
        { "group": "75-79" },
        { "group": "80-84" },
        { "group": "85-89" }
      ],
      "Pro-Doubles": [
        { "group": "16-24" },
        { "group": "25-29" },
        { "group": "30-34" },
        { "group": "35-39" },
        { "group": "40-44" },
        { "group": "45-49" },
        { "group": "50-54" },
        { "group": "55-59" },
        { "group": "60-64" },
        { "group": "65-69" },
        { "group": "70-74" }
      ],
      "Team Relay": [{ "group": "U40" }, { "group": "40+" }],
      "Adaptive": [
        { "group": "16-24" },
        { "group": "25-29" },
        { "group": "30-34" },
        { "group": "35-39" },
        { "group": "40-44" },
        { "group": "45-49" },
        { "group": "50-54" },
        { "group": "55-59" },
        { "group": "60-64" },
        { "group": "65-69" },
        { "group": "70-74" }
      ]
    }
  ],
  "divisions": [
    { "division": "Elite" },
    { "division": "Open" },
    { "division": "Pro" },
    { "division": "Doubles" },
    { "division": "Pro-Doubles" },
    { "division": "Team Relay" },
    { "division": "Adaptive" }
  ],
  "events": [
    {
      "id": 0,
      "location": "Heerenveen",
      "short": "HEE",
      "date": "14-17 mei 2026",
      "imgUrl": "https://ik.imagekit.io/wallable/Hyrox-events/hyrox-heerenveen.webp?updatedAt=1741607029112",
      "timestamp": "1778736864"
    },
    {
      "id": 1,
      "location": "Rotterdam",
      "short": "ROT",
      "date": "15-19 april 2026",
      "imgUrl": "https://ik.imagekit.io/wallable/Hyrox-events/hyrox-rotterdam-preview.webp",
      "timestamp": "1776231264"
    },
    {
      "id": 2,
      "location": "Valencia",
      "short": "VLC",
      "date": "8-9 maart 2025",
      "imgUrl": "https://ik.imagekit.io/wallable/Hyrox-events/hyrox-valencia.webp",
      "timestamp": "1741443516"
    },
    {
      "id": 3,
      "location": "Glasgow",
      "short": "GLA",
      "date": "13-16 maart 2025",
      "imgUrl": "https://hyroxnetherlands.com/wp-content/uploads/2023/10/HYROX-Glasgow-scaled-1-1280x697.jpg",
      "timestamp": "1741875516"
    },
    {
      "id": 4,
      "location": "Kopenhagen",
      "short": "CPH",
      "date": "14-15 maart 2025",
      "imgUrl": "https://hyroxnetherlands.com/wp-content/uploads/2023/10/hyrox-copenhagen.jpg",
      "timestamp": "1741961916"
    },
    {
      "id": 5,
      "location": "Málaga",
      "short": "MLG",
      "date": "16-19 april 2025",
      "imgUrl": "https://hyroxnetherlands.com/wp-content/uploads/2023/10/MLG-1-1.jpg",
      "timestamp": "1776317664"
    },
    {
      "id": 6,
      "location": "België",
      "short": "BEL",
      "date": "5-6 april 2025",
      "imgUrl": "https://hyroxnetherlands.com/wp-content/uploads/2024/07/Mechelen_zwart-wit-1280x854.jpeg",
      "timestamp": "1743862716"
    },
    {
      "id": 7,
      "location": "Keulen",
      "short": "CGN",
      "date": "16-19 april 2026",
      "imgUrl": "https://hyroxnetherlands.com/wp-content/uploads/2024/11/af38a0d3-23a3-4995-a054-fa55c8526537-1280x854.jpg",
      "timestamp": "1776317664"
    },
    {
      "id": 8,
      "location": "Amsterdam",
      "short": "AMS",
      "date": "10-13 oktober 2024",
      "imgUrl": "https://ik.imagekit.io/wallable/Hyrox-events/hyrox-amsterdam.jpg",
      "timestamp": "1728569916"
    },
    {
      "id": 9,
      "location": "Maastricht",
      "short": "MAA",
      "date": "1-2 februari 2025",
      "imgUrl": "https://ik.imagekit.io/wallable/Hyrox-events/hyrox-maastricht.jpg",
      "timestamp": "1728569916"
    },
    {
      "id": 10,
      "location": "Parijs",
      "short": "PAR",
      "date": "23-27 april 2026",
      "imgUrl": "https://ik.imagekit.io/wallable/Hyrox-events/hyrox-paris.jpg",
      "timestamp": "1776922464"
    },
    {
      "id": 11,
      "location": "Barcelona",
      "short": "BCN",
      "date": "14-17 mei 2026",
      "imgUrl": "https://ik.imagekit.io/wallable/Hyrox-events/hyrox-barcelona.jpg",
      "timestamp": "1778736864"
    },
    {
      "id": 12,
      "location": "London",
      "short": "LON",
      "date": "3-5 mei 2025",
      "imgUrl": "https://ik.imagekit.io/wallable/Hyrox-events/hyrox-london.jpg",
      "timestamp": "1746344242"
    },
    {
      "id": 13,
      "location": "Berlijn",
      "short": "BER",
      "date": "22-31 mei 2026",
      "imgUrl": "https://ik.imagekit.io/wallable/Hyrox-events/hyrox-berlin.jpg",
      "timestamp": "1779428064"
    },
    {
      "id": 14,
      "location": "Maastricht",
      "short": "MAA",
      "date": "19-21 september 2025",
      "imgUrl": "https://ik.imagekit.io/wallable/Hyrox-events/hyrox-maastricht.jpg",
      "timestamp": "1758267167"
    },
    {
      "id": 15,
      "location": "Utrecht",
      "short": "UTR",
      "date": "28-30 november 2025",
      "imgUrl": "https://ik.imagekit.io/wallable/Hyrox-events/hyrox-utrecht-placeholder.webp",
      "timestamp": "1764319471"
    },
    {
      "id": 16,
      "location": "Stuttgart",
      "short": "STR",
      "date": "31 oktober - 2 november 2025",
      "imgUrl": "https://ik.imagekit.io/wallable/Hyrox-events/hyrox-stuttgart-placeholder.webp",
      "timestamp": "1761900271"
    },
    {
      "id": 17,
      "location": "Parijs",
      "short": "PAR",
      "date": "22-26 oktober 2025",
      "imgUrl": "https://ik.imagekit.io/wallable/Hyrox-events/hyrox-parijs-placeholder.webp",
      "timestamp": "1761122671"
    },
    {
      "id": 18,
      "location": "London",
      "short": "LON",
      "date": "4-7 december 2025",
      "imgUrl": "https://ik.imagekit.io/wallable/Hyrox-events/hyrox-london-placeholder.webp",
      "timestamp": "1764837871"
    },
    {
      "id": 19,
      "location": "Frankfurt",
      "short": "FRA",
      "date": "12-14 december 2025",
      "imgUrl": "https://ik.imagekit.io/wallable/Hyrox-events/hyrox-frankfurt-placeholder.webp",
      "timestamp": "1765529071"
    },
    {
      "id": 20,
      "location": "Gent",
      "short": "GNT",
      "date": "12-14 december 2025",
      "imgUrl": "https://ik.imagekit.io/wallable/Hyrox-events/hyrox-gent-placeholder.webp",
      "timestamp": "1765529071"
    },
    {
      "id": 21,
      "location": "Amsterdam",
      "short": "AMS",
      "date": "21-25 januari 2026",
      "imgUrl": "https://ik.imagekit.io/wallable/Hyrox-events/hyrox-amsterdam.jpg",
      "timestamp": "1768981896"
    },
    {
      "id": 22,
      "location": "Turijn",
      "short": "TRN",
      "date": "30 jan - 1 feb 2026",
      "imgUrl": "https://hyrox.com/wp-content/uploads/2023/09/Turin-1-1280x852.jpg",
      "timestamp": "1769759496"
    },
    {
      "id": 23,
      "location": "Wenen",
      "short": "VIE",
      "date": "6-8 februari 2026",
      "imgUrl": "https://hyrox.com/wp-content/uploads/2025/07/Vienna_Titelpic.png",
      "timestamp": "1770364296"
    },
    {
      "id": 24,
      "location": "Bilbao",
      "short": "BLB",
      "date": "7-8 februari 2026",
      "imgUrl": "https://hyrox.com/wp-content/uploads/2023/10/BLB-1-1280x851.jpg",
      "timestamp": "1770364296"
    },
    {
      "id": 25,
      "location": "Istanbul",
      "short": "IST",
      "date": "13-14 februari 2026",
      "imgUrl": "https://hyrox.com/wp-content/uploads/2025/07/Istanbul-6-2-1280x721.jpg",
      "timestamp": "1770364296"
    },
    {
      "id": 26,
      "location": "Kopenhagen",
      "short": "CPH",
      "date": "13-15 maart 2026",
      "imgUrl": "https://hyrox.com/wp-content/uploads/2025/07/WebP-Image.jpg",
      "timestamp": "1773388296"
    },
    {
      "id": 27,
      "location": "London",
      "short": "LON",
      "date": "24-29 maart 2026",
      "imgUrl": "https://hyrox.com/wp-content/uploads/2025/07/OLY.jpg",
      "timestamp": "1774338696"
    },
    {
      "id": 28,
      "location": "Mechelen",
      "short": "MEC",
      "date": "26-29 maart 2026",
      "imgUrl": "https://hyrox.com/wp-content/uploads/2024/07/Mechelen_zwart-wit-1280x854.jpeg",
      "timestamp": "1774338696"
    },
    {
      "id": 29,
      "location": "Helsinki",
      "short": "HEL",
      "date": "9-10 mei 2026",
      "imgUrl": "https://hyrox.com/wp-content/uploads/2025/07/hyrox-helsinki-1280x720.png",
      "timestamp": "1778316950"
    }
  ]
}
